import Base from '../base';
import apiUrls from '../api-urls';

export default class LogsAPI extends Base {
    async sendLog(params) {
        return this.apiClient.post(apiUrls.logs.errorLogger, params);
    }
}